import { useState, useRef } from "react";
import "@/App.css";
import { motion, useInView } from "framer-motion";
import { Toaster, toast } from "sonner";
import { Calendar, Clock, MapPin, Shirt, Gift, Users, Mail, User, MessageSquare, ImageIcon, Sparkles, X, Send, Hotel, Ban, CalendarX } from "lucide-react";

// ТВОЯТ TELEGRAM БОТ КОНФИГУРАЦИЯ
const TELEGRAM_BOT_TOKEN = "8261945214:AAGJHf8SQEx81XshroNeSshSgiBbzwuX1UM";
const TELEGRAM_CHAT_ID = "-1003898231951"; // ID на групата "60 ГОДИНИ | КРАСИМИР БАЛЪКОВ"

// Google Maps link
const GOOGLE_MAPS_LINK = "https://www.google.com/maps?ll=42.659904,23.336349&z=14&t=m&hl=bg&gl=BG&mapclient=embed&q=%D0%9B%D0%BE%D0%B2%D0%B5%D0%BD,+%D0%B1%D1%83%D0%BB.+%E2%80%9E%D0%A1%D0%B8%D0%BC%D0%B5%D0%BE%D0%BD%D0%BE%D0%B2%D1%81%D0%BA%D0%BE+%D1%88%D0%BE%D1%81%D0%B5%E2%80%9C+4+1700+%D0%A1%D0%BE%D1%84%D0%B8%D1%8F";

// КРАЕН СРОК ЗА ЗАЯВКИ
const REGISTRATION_DEADLINE = new Date('2026-03-25T23:59:59');

// ФУНКЦИЯ ЗА ПРОВЕРКА ДАЛИ СРОКЪТ Е ИЗТЕКЪЛ
const isRegistrationClosed = () => {
  const now = new Date();
  return now > REGISTRATION_DEADLINE;
};

const content = {
  bg: {
    // Hero Section
    heroTitle: "60",
    heroSubtitle: "ГОДИНИ",
    heroName: "КРАСИМИР БАЛЪКОВ",
    heroTagline: "Юбилейна вечер",
    cta: "ПОТВЪРДИ МЕНЮ / ПРИСЪСТВИЕ",
    thankyou: "С радост ще отпразнувам своя 60-годишен юбилей заедно с Вас.\nВашето присъствие е най-ценният подарък за мен.\nМоля, не носете цветя и материални изненади, ще се радвам, ако насочим вниманието си към кауза, която от години подкрепям като посланик на добра воля.\nТова е каузата SOS Детски селища.\nБлагодаря Ви, че ще направим този ден още по-смислен.\nДрескод: спортно-елегантно.",
    
    // Event Details
    date: "06.04.2026",
    dateLabel: "ДАТА",
    welcomeDrink: "WELCOME DRINK",
    welcomeTime: "18:00",
    dinner: "ВЕЧЕРЯ",
    dinnerTime: "19:00",
    dresscode: "СПОРТНО-ЕЛЕГАНТНО",
    dresscodeLabel: "ДРЕСКОД",
    
    // Location
    location: "ВИЖ НА КАРТАТА",
    locationLabel: "ЛОКАЦИЯ",
    parking: "ОСИГУРЕН",
    parkingLabel: "ПАРКИНГ",
    address: "бул. „Симеоновско шосе“ 4, София",
    
    // Menu
    menuTitle: "МЕНЮ",
    saladSection: {
      title: "Избор на салата",
      items: [
        { 
          id: 'traditional',
          title: 'Традиционна българска салата',
          description: 'Домати, краставици, сирене, лук, магданоз',
          image: '/images/menu/salad1.jpg'
        },
        { 
          id: 'goatCheese',
          title: 'Салата със запечено козе сирене и смокини',
          description: 'Микс салата, запечено козе сирене, пресни смокини, балсамово редукто',
          image: '/images/menu/salad2.jpg'
        }
      ]
    },
    pastaSection: {
      title: 'Паста (включена в менюто)',
      description: 'Талеолини алеолио с темпериран тартар от скариди, октопод и калмари',
      image: '/images/menu/pasta.jpg'
    },
    mainCourses: {
      title: 'Избор на основни ястия',
      items: [
        { 
          id: 'fish', 
          title: 'Риба', 
          description: 'Камбала на фурна с пюре от кореноплодни, бейби романа и аспержи', 
          image: '/images/menu/fish.jpg'
        },
        { 
          id: 'veal', 
          title: 'Телешко', 
          description: 'Телешки ростбийф с трюфел пюре, артишок и аспержи', 
          image: '/images/menu/veal.jpg'
        },
        { 
          id: 'porkRibs', 
          title: 'Свински ребра', 
          description: 'Свински ребра с полента, пюре от царевица и чатни от ябълки', 
          image: '/images/menu/pork-ribs.jpg'
        }
      ]
    },

    // Hotel Section
    hotelTitle: "ХОТЕЛ ХАЯШИ",
    hotelSubtitle: "НОЩУВКА",
    hotelDescription: "Хотел Хаяши се намира над ресторанта и предлага удобства за гостите на събитието.",
    hotelSingleRoom: "Единична стая",
    hotelDoubleRoom: "Двойна стая",
    hotelSinglePrice: "85 EUR",
    hotelDoublePrice: "85 EUR",
    hotelPerNight: "на вечер",
    hotelBookButton: "Запази стая",
    hotelInfo: "Цената е за стая с включена закуска. Лимитиран брой стаи - резервирайте навреме!",
    hotelPhone: "За резервации на стая:",
    hotelPhoneNumber: "+359 879201010",
    hotelReference: "ПОСОЧЕТЕ, ЧЕ СТЕ ГОСТ НА КРАСИМИР БАЛЪКОВ",
    
    // Attendance Section
    attendanceTitle: "ЗАЯВКИ ЗА ПРИСЪСТВИЕ",
    attendanceDeadline: "ЗАЯВКИТЕ СЕ ПРИЕМАТ ДО 25 МАРТ 2026",
    attendanceDeadlineWarning: "След тази дата няма да може да потвърдите присъствие",
    
    // Registration Closed Section
    registrationClosedTitle: "ЗАПИСВАНЕТО ПРИКЛЮЧИ",
    registrationClosedSubtitle: "Крайният срок за заявки беше 25 март 2026",
    registrationClosedMessage: "Благодарим на всички, които потвърдиха своето присъствие! Очакваме ви с нетърпение на 6 април 2026 в 18:00 часа.",
    registrationClosedNote: "Ако имате въпроси, моля свържете се с нас на посочения телефон.",
    registrationClosedPhone: "+359 879201010",
    
    // RSVP Section
    rsvpTitle: "ПОТВЪРДИ",
    rsvpSubtitle: "ПРИСЪСТВИЕ",
    guestCount: "Брой гости",
    guestCount1: "1 гост",
    guestCount2: "2 гости",
    
    formLabels: {
      fullName: "Име и фамилия",
      guest1Name: "Име на гост 1",
      guest2Name: "Име на гост 2",
      saladChoice1: "Избор на салата - Гост 1",
      saladChoice2: "Избор на салата - Гост 2",
      foodChoice1: "Избор на основно ястие - Гост 1",
      foodChoice2: "Избор на основно ястие - Гост 2",
      hotelNeeded: "Нужда от хотел?",
      specialRequirements: "Специални изисквания",
      submit: "Изпрати"
    },
    placeholders: {
      fullName: "Вашето име",
      guestName: "Име на гост",
      specialRequirements: "Алергии, диети..."
    },
    saladOptions: {
      traditional: "Традиционна българска салата",
      goatCheese: "Салата със запечено козе сирене и смокини"
    },
    foodOptions: {
      fish: "Риба",
      veal: "Телешко",
      porkRibs: "Свински ребра"
    },
    hotelOptions: {
      yes: "Да",
      no: "Не"
    },
    
    // Messages
    successMessage: "Благодарим! Вашата заявка беше изпратена успешно.",
    errorMessage: "Моля, попълнете всички задължителни полета.",
    errorGuest2Name: "Моля, въведете име на втория гост",
    telegramSending: "Изпращане към Telegram...",
    shareTitle: "ИЗПРАЩАНЕ...",
    shareSubtitle: "Моля, изчакайте",
    
    // Lightbox
    viewEventDetails: "Натиснете бутона за да видите датата и часа на събитието",
    eventDateTime: "Виж Локация",
    reserveRoom: "Резервирай стая",
    
    // Footer
    footerName: "КРАСИМИР БАЛЪКОВ"
  },
  
  en: {
    // Hero Section
    heroTitle: "60",
    heroSubtitle: "YEARS",
    heroName: "KRASIMIR BALAKOV",
    heroTagline: "Jubilee Evening",
    cta: "CONFIRM MENU / ATTENDANCE",
    thankyou: "I would be happy for us to celebrate together, but the real gift for me would be your support for a cause that I hold close to my heart. Since 1996, I have been a Goodwill Ambassador for SOS Children's Villages, and I kindly ask you to refrain from material gifts. During the evening, I will tell you more about this cause. If you choose to leave your contribution in an envelope, you are not just donating; you are becoming part of the mission to provide a home and a family to the children who need it most.",
    
    // Event Details
    date: "06.04.2026",
    dateLabel: "DATE",
    welcomeDrink: "WELCOME DRINK",
    welcomeTime: "18:00",
    dinner: "DINNER",
    dinnerTime: "19:00",
    dresscode: "SPORTY-ELEGANT",
    dresscodeLabel: "DRESS CODE",
    
    // Location
    location: "VIEW ON MAP",
    locationLabel: "LOCATION",
    parking: "AVAILABLE",
    parkingLabel: "PARKING",
    address: "bul. „Simeonovsko shose“ 4, Sofia",
    
    // Menu
    menuTitle: "MENU",
    saladSection: {
      title: "Salad Choice",
      items: [
        { 
          id: 'traditional',
          title: 'Traditional Bulgarian salad',
          description: 'Tomatoes, cucumbers, white cheese, onion, parsley',
          image: '/images/menu/salad1.jpg'
        },
        { 
          id: 'goatCheese',
          title: 'Salad with baked goat cheese and figs',
          description: 'Mixed salad, baked goat cheese, fresh figs, balsamic reduction',
          image: '/images/menu/salad2.jpg'
        }
      ]
    },
    pastaSection: {
      title: 'Pasta (included in the menu)',
      description: 'Homemade pasta with shrimp, octopus and calamari tartare',
      image: '/images/menu/pasta.jpg'
    },
    mainCourses: {
      title: 'Selection of main dishes',
      items: [
        { 
          id: 'fish', 
          title: 'Fish', 
          description: 'Baked halibut with root vegetable puree, baby tomatoes and asparagus', 
          image: '/images/menu/fish.jpg'
        },
        { 
          id: 'veal', 
          title: 'Veal', 
          description: 'Veal roastbeef with truffle puree, artichoke and asparagus', 
          image: '/images/menu/veal.jpg'
        },
        { 
          id: 'porkRibs', 
          title: 'Pork ribs', 
          description: 'Pork ribs with polenta, corn puree and apple chutney', 
          image: '/images/menu/pork-ribs.jpg'
        }
      ]
    },

    // Hotel Section
    hotelTitle: "HOTEL HAYASHI",
    hotelSubtitle: "OVERNIGHT STAY",
    hotelDescription: "Hotel Hayashi is located above the restaurant and offers accommodations for event guests.",
    hotelSingleRoom: "Single Room",
    hotelDoubleRoom: "Double Room",
    hotelSinglePrice: "85 EUR",
    hotelDoublePrice: "85 EUR",
    hotelPerNight: "per night",
    hotelBookButton: "Book Room",
    hotelInfo: "Price includes breakfast. Limited rooms available - book in advance!",
    hotelPhone: "For room reservations:",
    hotelPhoneNumber: "+359 879201010",
    hotelReference: "INDICATE THAT YOU ARE A GUEST OF KRASIMIR BALAKOV",

    // Attendance Section
    attendanceTitle: "ATTENDANCE REQUESTS",
    attendanceDeadline: "REQUESTS ARE ACCEPTED UNTIL MARCH 25, 2026",
    attendanceDeadlineWarning: "After this date you will not be able to confirm attendance",
    
    // Registration Closed Section
    registrationClosedTitle: "REGISTRATION CLOSED",
    registrationClosedSubtitle: "The deadline for requests was March 25, 2026",
    registrationClosedMessage: "Thank you to everyone who confirmed their attendance! We look forward to seeing you on April 6, 2026 at 6:00 PM.",
    registrationClosedNote: "If you have any questions, please contact us at the number below.",
    registrationClosedPhone: "+359 879201010",
    
    // RSVP Section
    rsvpTitle: "CONFIRM",
    rsvpSubtitle: "ATTENDANCE",
    guestCount: "Number of guests",
    guestCount1: "1 guest",
    guestCount2: "2 guests",
    
    formLabels: {
      fullName: "Full Name",
      guest1Name: "Guest 1 Name",
      guest2Name: "Guest 2 Name",
      saladChoice1: "Salad Choice - Guest 1",
      saladChoice2: "Salad Choice - Guest 2",
      foodChoice1: "Main Course Choice - Guest 1",
      foodChoice2: "Main Course Choice - Guest 2",
      hotelNeeded: "Hotel needed?",
      specialRequirements: "Special Requirements",
      submit: "Submit"
    },
    placeholders: {
      fullName: "Your name",
      guestName: "Guest name",
      specialRequirements: "Allergies, diets..."
    },
    saladOptions: {
      traditional: "Traditional Bulgarian salad",
      goatCheese: "Salad with baked goat cheese and figs"
    },
    foodOptions: {
      fish: "Fish",
      veal: "Veal",
      porkRibs: "Pork ribs"
    },
    hotelOptions: {
      yes: "Yes",
      no: "No"
    },
    
    // Messages
    successMessage: "Thank you! Your request was sent successfully.",
    errorMessage: "Please fill all required fields.",
    errorGuest2Name: "Please enter the second guest's name",
    telegramSending: "Sending to Telegram...",
    shareTitle: "SENDING...",
    shareSubtitle: "Please wait",
    
    // Lightbox
    viewEventDetails: "Click the button to see the event date and time",
    eventDateTime: "See Location",
    reserveRoom: "Reserve Room",
    
    // Footer
    footerName: "KRASIMIR BALAKOV"
  }
};

// Pop-up animation variants
const popUp = {
  hidden: { opacity: 0, y: 80, scale: 0.9 },
  visible: { 
    opacity: 1, 
    y: 0, 
    scale: 1,
    transition: { 
      duration: 0.8, 
      ease: [0.16, 1, 0.3, 1]
    }
  }
};

const staggerContainer = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: { staggerChildren: 0.15, delayChildren: 0.1 }
  }
};

// Animated Section Component
const AnimatedSection = ({ children, className, delay = 0 }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  
  return (
    <motion.div
      ref={ref}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      variants={popUp}
      transition={{ delay }}
      className={className}
    >
      {children}
    </motion.div>
  );
};

// Hotel Section Component - COMPLETE WITH TRANSLATIONS
const HotelSection = ({ t, onBookClick, lang }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  return (
    <motion.section
      ref={ref}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      variants={popUp}
      className="section-dark py-16 md:py-24 px-4 md:px-6"
      data-testid="hotel-section"
    >
      <div className="max-w-4xl mx-auto">
        <div className="text-center mb-10">
          <Hotel className="mx-auto mb-4" style={{ color: 'var(--gold-crayola)' }} size={36} />
          <h2 
            className="text-gold tracking-[0.4em] mb-4"
            style={{ 
              fontFamily: 'var(--fontFamily-forum)',
              fontSize: 'clamp(2rem, 6vw, 3rem)',
              fontWeight: 300
            }}
          >
            {t.hotelTitle}
          </h2>
          <p className="text-dim tracking-[0.2em] text-sm md:text-sm mb-2">{t.hotelSubtitle}</p>
          <div className="gold-line" />
        </div>

        <p className="text-silver text-center mb-10 max-w-2xl mx-auto leading-relaxed">
          {t.hotelDescription}
        </p>

        {/* Room Card - Single Option at 85 EUR */}
        <div className="flex justify-center mb-10">
          <motion.div 
            variants={popUp}
            className="border border-gold-crayola/20 p-6 md:p-8 text-center hover:border-gold-crayola/50 transition-all duration-300 w-full md:w-2/3 lg:w-1/2"
          >
            <h3 
              className="text-gold text-xl md:text-2xl mb-2"
              style={{ fontFamily: 'var(--fontFamily-forum)' }}
            >
              {t.hotelSingleRoom}
            </h3>
            <div className="text-3xl md:text-4xl text-white font-light mb-1">
              85 EUR
            </div>
            <p className="text-dim text-sm mb-4">{t.hotelPerNight}</p>
            <motion.button
              onClick={() => onBookClick('single')}
              className="btn-gold w-full py-3 text-sm"
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
            >
              {t.hotelBookButton}
            </motion.button>
          </motion.div>
        </div>

        {/* Additional Info with HIGHLIGHTED reference text */}
        <div className="text-center border-t border-gold-crayola/20 pt-6">
          <p className="text-dim text-sm mb-2">{t.hotelInfo}</p>
          <p className="text-gold text-sm">{t.hotelPhone}</p>
          <p className="text-white text-lg font-light mb-3">{t.hotelPhoneNumber}</p>
          
          {/* HIGHLIGHTED REFERENCE TEXT - TRANSLATED BASED ON LANGUAGE */}
          <div 
            className="inline-block px-6 py-3 mb-2 relative overflow-hidden"
            style={{ 
              background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.12) 0%, rgba(212, 175, 55, 0.25) 100%)',
              borderLeft: '4px solid var(--gold-crayola)',
              borderRight: '4px solid var(--gold-crayola)',
              boxShadow: '0 4px 15px rgba(212, 175, 55, 0.2)'
            }}
          >
            <p 
              className="text-gold font-bold text-sm md:text-base tracking-wider"
              style={{ 
                fontFamily: 'var(--fontFamily-forum)',
                letterSpacing: '0.1em'
              }}
            >
              {lang === "bg" ? "📌 ПОСОЧЕТЕ, ЧЕ СТЕ ГОСТ НА КРАСИМИР БАЛЪКОВ 📌" : "📌 INDICATE THAT YOU ARE A GUEST OF KRASIMIR BALAKOV 📌"}
            </p>
          </div>
        </div>
      </div>
    </motion.section>
  );
};

// Hotel Lightbox Component - COMPLETE WITH TRANSLATIONS
const HotelLightbox = ({ show, onClose, roomType, t, lang }) => {
  if (!show) return null;

  // Format phone number for tel: link (remove spaces)
  const phoneNumber = t.hotelPhoneNumber.replace(/\s+/g, '');

  return (
    <motion.div 
      className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
      style={{ background: 'rgba(0,0,0,0.95)' }}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      onClick={onClose}
    >
      <button 
        className="absolute top-6 right-6 z-[10000] hover:scale-110 transition-transform"
        onClick={onClose}
        style={{ color: 'var(--gold-crayola)' }}
      >
        <X size={32} />
      </button>
      
      <motion.div
        initial={{ scale: 0.8, opacity: 0, y: 50 }}
        animate={{ scale: 1, opacity: 1, y: 0 }}
        transition={{ duration: 0.4, type: "spring" }}
        onClick={(e) => e.stopPropagation()}
        className="bg-black border border-gold-crayola/30 p-6 md:p-10 max-w-md w-full"
      >
        <h3 
          className="text-gold text-center mb-4 tracking-wider"
          style={{ 
            fontFamily: 'var(--fontFamily-forum)',
            fontSize: 'clamp(1.5rem, 5vw, 2rem)'
          }}
        >
          {t.hotelTitle}
        </h3>

        <div className="mb-6 text-center">
          <p className="text-white text-xl mb-2">
            {t.hotelSingleRoom}
          </p>
          <p className="text-gold text-3xl font-light mb-1">
            85 EUR
          </p>
          <p className="text-dim text-sm">{t.hotelPerNight}</p>
        </div>

        <div className="border-t border-gold-crayola/20 pt-4 mb-4">
          <p className="text-dim text-sm text-center mb-4">
            {t.hotelInfo}
          </p>
          
          <div 
            className="p-4 mb-4 text-center"
            style={{ 
              background: 'rgba(212, 175, 55, 0.08)',
              border: '1px dashed var(--gold-crayola)'
            }}
          >
            <p className="text-gold text-sm mb-2 tracking-wider">{t.hotelPhone}</p>
            <a 
              href={`tel:${phoneNumber}`}
              className="text-white text-xl font-light hover:text-gold transition-colors inline-block"
              style={{ fontFamily: 'var(--fontFamily-forum)' }}
            >
              {t.hotelPhoneNumber}
            </a>
          </div>

          {/* HIGHLIGHTED REFERENCE TEXT IN LIGHTBOX - TRANSLATED */}
          <div 
            className="p-4 text-center relative"
            style={{ 
              background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.15) 0%, rgba(212, 175, 55, 0.3) 100%)',
              border: '2px solid var(--gold-crayola)',
              borderRadius: '8px'
            }}
          >
            <div 
              className="absolute inset-0 opacity-10"
              style={{
                background: 'repeating-linear-gradient(45deg, var(--gold-crayola) 0px, var(--gold-crayola) 10px, transparent 10px, transparent 20px)'
              }}
            />
            {lang === "bg" ? (
              <p 
                className="text-gold font-bold text-base relative z-10"
                style={{ 
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                  fontFamily: 'var(--fontFamily-forum)',
                  letterSpacing: '0.08em'
                }}
              >
                ПОСОЧЕТЕ, ЧЕ СТЕ ГОСТ НА<br />
                <span className="text-xl tracking-wider">КРАСИМИР БАЛЪКОВ</span>
              </p>
            ) : (
              <p 
                className="text-gold font-bold text-base relative z-10"
                style={{ 
                  textShadow: '0 2px 4px rgba(0,0,0,0.3)',
                  fontFamily: 'var(--fontFamily-forum)',
                  letterSpacing: '0.08em'
                }}
              >
                INDICATE THAT YOU ARE A GUEST OF<br />
                <span className="text-xl tracking-wider">KRASIMIR BALAKOV</span>
              </p>
            )}
          </div>
        </div>

        <div className="flex gap-3">
          <motion.button
            onClick={onClose}
            className="flex-1 border border-gold-crayola/30 text-gold py-3 text-sm hover:bg-gold-crayola/10 transition-colors"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            {lang === "bg" ? "Затвори" : "Close"}
          </motion.button>
          
          <motion.a
            href={`tel:${phoneNumber}`}
            className="flex-1 btn-gold text-center py-3 text-sm"
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
          >
            {lang === "bg" ? "Обади се" : "Call"}
          </motion.a>
        </div>
      </motion.div>
    </motion.div>
  );
};

// Registration Closed Section Component
const RegistrationClosedSection = ({ t, lang }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });
  const phoneNumber = t.registrationClosedPhone.replace(/\s+/g, '');

  return (
    <motion.section
      ref={ref}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      variants={popUp}
      className="section-dark py-16 md:py-24 px-4 md:px-6"
      data-testid="registration-closed-section"
    >
      <div className="max-w-2xl mx-auto text-center">
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring" }}
          className="mb-6"
        >
          <div className="w-20 h-20 mx-auto rounded-full border-2 border-gold-crayola flex items-center justify-center">
            <CalendarX size={40} className="text-gold-crayola" />
          </div>
        </motion.div>
        
        <h2 
          className="text-gold tracking-[0.3em] mb-4"
          style={{ 
            fontFamily: 'var(--fontFamily-forum)',
            fontSize: 'clamp(1.5rem, 5vw, 2.5rem)',
            fontWeight: 300
          }}
        >
          {t.registrationClosedTitle}
        </h2>
        
        <div className="gold-line mx-auto w-16 mb-6" />
        
        <p className="text-silver text-lg mb-2">
          {t.registrationClosedSubtitle}
        </p>
        
        <div className="bg-gold-crayola/10 border border-gold-crayola/30 p-6 my-6">
          <p className="text-white leading-relaxed">
            {t.registrationClosedMessage}
          </p>
        </div>
        
        <p className="text-dim text-sm mb-3">
          {t.registrationClosedNote}
        </p>
        
        <a 
          href={`tel:${phoneNumber}`}
          className="inline-block btn-gold px-6 py-3 text-sm mt-2"
        >
          {t.registrationClosedPhone}
        </a>
      </div>
    </motion.section>
  );
};

function App() {
  const [lang, setLang] = useState("bg");
  const [formData, setFormData] = useState({
    fullName: "",
    guestCount: "1",
    guest2Name: "",
    saladChoice1: "traditional",
    saladChoice2: "traditional",
    foodChoice1: "fish",
    foodChoice2: "fish",
    hotelNeeded: "no",
    specialRequirements: ""
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [lightboxImage, setLightboxImage] = useState(null);
  const [showLightbox, setShowLightbox] = useState(false);
  const [showHotelLightbox, setShowHotelLightbox] = useState(false);
  const [selectedRoomType, setSelectedRoomType] = useState('single');

  // Проверка дали срокът за записване е изтекъл
  const registrationClosed = isRegistrationClosed();
  const t = content[lang];

  // ФУНКЦИЯ ЗА ФОРМАТИРАНЕ НА СЪОБЩЕНИЕТО - ВИНАГИ НА БЪЛГАРСКИ
  const formatMessage = (data) => {
    let message = "";
    
    message = `🎉 *НОВА РЕГИСТРАЦИЯ ЗА 60-ТИЯ РОЖДЕН ДЕН* 🎉\n\n`;
    message += `━━━━━━━━━━━━━━━━━━━━━\n\n`;
    message += `👤 *Регистрирал се:* ${data.fullName}\n`;
    message += `👥 *Брой гости:* ${data.guestCount}\n`;
    message += `🏨 *Нужда от хотел:* ${data.hotelNeeded === "yes" ? "ДА" : "НЕ"}\n\n`;
    
    if (data.guestCount === "1") {
      message += `━━━ ГОСТ 1 ━━━\n`;
      message += `👤 *Име:* ${data.fullName}\n`;
      message += `🥗 *Салата:* ${content.bg.saladOptions[data.saladChoice1]}\n`;
      message += `🍽️ *Основно:* ${content.bg.foodOptions[data.foodChoice1]}\n\n`;
    } else if (data.guestCount === "2") {
      message += `━━━ ГОСТ 1 ━━━\n`;
      message += `👤 *Име:* ${data.fullName}\n`;
      message += `🥗 *Салата:* ${content.bg.saladOptions[data.saladChoice1]}\n`;
      message += `🍽️ *Основно:* ${content.bg.foodOptions[data.foodChoice1]}\n\n`;
      
      message += `━━━ ГОСТ 2 ━━━\n`;
      message += `👤 *Име:* ${data.guest2Name}\n`;
      message += `🥗 *Салата:* ${content.bg.saladOptions[data.saladChoice2]}\n`;
      message += `🍽️ *Основно:* ${content.bg.foodOptions[data.foodChoice2]}\n\n`;
    }
    
    if (data.specialRequirements) {
      message += `📝 *Специални изисквания:*\n_${data.specialRequirements}_\n\n`;
    }
    
    message += `━━━━━━━━━━━━━━━━\n`;

    return message;
  };

  // ФУНКЦИЯ ЗА ИЗПРАЩАНЕ КЪМ TELEGRAM
  const sendToTelegram = async (data) => {
    const message = formatMessage(data);
    
    try {
      const response = await fetch(`https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendMessage`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          chat_id: TELEGRAM_CHAT_ID,
          text: message,
          parse_mode: 'Markdown'
        })
      });

      const result = await response.json();
      
      if (result.ok) {
        toast.success(content.bg.successMessage);
        setSubmitted(true);
      } else {
        throw new Error('Failed to send message');
      }
    } catch (error) {
      console.error('Telegram error:', error);
      toast.error(content.bg.errorMessage);
      setShowLightbox(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // ПРОВЕРКА ЗА КРАЕН СРОК - АКО Е ИЗТЕКЪЛ, НЕ ИЗПРАЩА
    if (registrationClosed) {
      toast.error(lang === "bg" 
        ? "❌ Крайният срок за заявки изтече на 25 март 2026" 
        : "❌ The deadline for requests expired on March 25, 2026");
      return;
    }
    
    // Валидация
    if (!formData.fullName) {
      toast.error(t.errorMessage);
      return;
    }

    if (formData.guestCount === "2" && !formData.guest2Name) {
      toast.error(t.errorGuest2Name);
      return;
    }

    setIsSubmitting(true);
    setShowLightbox(true);

    try {
      await sendToTelegram(formData);
    } catch (error) {
      console.error('Error:', error);
      toast.error(t.errorMessage);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleHotelBook = (roomType) => {
    setSelectedRoomType(roomType);
    setShowHotelLightbox(true);
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    setFormData(prev => ({ 
      ...prev, 
      [name]: type === 'checkbox' ? checked : value 
    }));
  };

  const scrollToRSVP = () => {
    if (!registrationClosed) {
      document.getElementById("rsvp-section")?.scrollIntoView({ behavior: "smooth" });
    }
  };

  const detailsRef = useRef(null);
  const detailsInView = useInView(detailsRef, { once: true, margin: "-50px" });

  const menuRef = useRef(null);
  const menuInView = useInView(menuRef, { once: true, margin: "-50px" });

  return (
    <div className="App" data-testid="jubilee-app">
      <Toaster 
        position="top-center" 
        toastOptions={{
          style: {
            background: '#0a0a0a',
            color: '#fff',
            border: '1px solid rgba(212, 175, 55, 0.3)',
            borderRadius: '0'
          }
        }}
      />
      
      {/* Lightbox за изображения от менюто */}
      {lightboxImage && !showLightbox && (
        <motion.div 
          className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
          style={{ background: 'rgba(0,0,0,0.95)' }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => setLightboxImage(null)}
        >
          <button 
            className="absolute top-6 right-6 z-[10000] hover:scale-110 transition-transform"
            onClick={() => setLightboxImage(null)}
            style={{ color: 'var(--gold-crayola)' }}
          >
            <X size={32} />
          </button>
          <motion.div
            initial={{ scale: 0.8, opacity: 0 }}
            animate={{ scale: 1, opacity: 1 }}
            transition={{ duration: 0.3 }}
            onClick={(e) => e.stopPropagation()}
            className="max-w-3xl max-h-[85vh] relative"
          >
            <img 
              src={lightboxImage.src} 
              alt={lightboxImage.title}
              className="max-w-full max-h-[80vh] object-contain"
            />
            <p 
              className="text-center mt-4 text-gold tracking-wider"
              style={{ fontFamily: 'var(--fontFamily-forum)', color: 'var(--gold-crayola)' }}
            >
              {lightboxImage.title}
            </p>
          </motion.div>
        </motion.div>
      )}

      {/* Lightbox за изпращане към Telegram - С ДВА БУТОНА (И ДВАТА БЕЖОВИ) */}
      {showLightbox && (
        <motion.div 
          className="fixed inset-0 z-[9999] flex items-center justify-center p-4"
          style={{ background: 'rgba(0,0,0,0.95)' }}
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          onClick={() => !isSubmitting && setShowLightbox(false)}
        >
          <button 
            className="absolute top-6 right-6 z-[10000] hover:scale-110 transition-transform"
            onClick={() => !isSubmitting && setShowLightbox(false)}
            style={{ color: 'var(--gold-crayola)' }}
            disabled={isSubmitting}
          >
            <X size={32} />
          </button>
          
          <motion.div
            initial={{ scale: 0.8, opacity: 0, y: 50 }}
            animate={{ scale: 1, opacity: 1, y: 0 }}
            transition={{ duration: 0.4, type: "spring" }}
            onClick={(e) => e.stopPropagation()}
            className="bg-black border border-gold-crayola/30 p-6 md:p-10 max-w-md w-full"
          >
            {isSubmitting ? (
              <>
                <motion.div
                  animate={{ rotate: 360 }}
                  transition={{ duration: 2, repeat: Infinity, ease: "linear" }}
                  className="w-16 h-16 mx-auto mb-6 border-2 border-gold-crayola border-t-transparent rounded-full"
                />
                <h3 
                  className="text-gold text-center mb-4 tracking-wider"
                  style={{ 
                    fontFamily: 'var(--fontFamily-forum)',
                    fontSize: 'clamp(1.2rem, 4vw, 1.8rem)'
                  }}
                >
                  {t.shareTitle}
                </h3>
                <p className="text-dim text-sm text-center">
                  {t.telegramSending}
                </p>
              </>
            ) : (
              <>
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ delay: 0.2, type: "spring" }}
                  className="text-gold text-6xl text-center mb-4"
                >
                  ✓
                </motion.div>
                
                <h3 
                  className="text-gold text-center mb-4 tracking-wider"
                  style={{ 
                    fontFamily: 'var(--fontFamily-forum)',
                    fontSize: 'clamp(1.5rem, 5vw, 2rem)'
                  }}
                >
                  {lang === "bg" ? "УСПЕШНА ЗАЯВКА" : "SUCCESSFUL REQUEST"}
                </h3>
                
                <p className="text-dim text-sm text-center mb-6">
                  {t.successMessage}
                </p>

                {/* Детайли за събитието */}
                <div className="border-t border-gold-crayola/20 pt-4 mb-4">
                  <h4 
                    className="text-gold text-center mb-3 text-sm tracking-wider"
                    style={{ fontFamily: 'var(--fontFamily-forum)' }}
                  >
                    {lang === "bg" ? "ДЕТАЙЛИ ЗА СЪБИТИЕТО" : "EVENT DETAILS"}
                  </h4>
                  
                  <div className="space-y-2 text-sm">
                    <div className="flex justify-between items-center py-1 border-b border-white/5">
                      <span className="text-dim">{lang === "bg" ? "Дата:" : "Date:"}</span>
                      <span className="text-white font-light">{t.date}</span>
                    </div>
                    
                    <div className="flex justify-between items-center py-1 border-b border-white/5">
                      <span className="text-dim">{lang === "bg" ? "Welcome drink:" : "Welcome drink:"}</span>
                      <span className="text-white font-light">{t.welcomeTime}</span>
                    </div>
                    
                    <div className="flex justify-between items-center py-1 border-b border-white/5">
                      <span className="text-dim">{lang === "bg" ? "Вечеря:" : "Dinner:"}</span>
                      <span className="text-white font-light">{t.dinnerTime}</span>
                    </div>
                    
                    <div className="flex justify-between items-center py-1 border-b border-white/5">
                      <span className="text-dim">{lang === "bg" ? "Дрескод:" : "Dress code:"}</span>
                      <span className="text-white font-light">{t.dresscode}</span>
                    </div>
                    
                    <div className="flex justify-between items-center py-1 border-b border-white/5">
                      <span className="text-dim">{lang === "bg" ? "Локация:" : "Location:"}</span>
                      <span className="text-white font-light">бул. „Симеоновско шосе“ 4, София</span>
                    </div>
                    
                    {/* Показване на избора за хотел */}
                    {formData.hotelNeeded === "yes" && (
                      <div className="flex justify-between items-center py-1 border-b border-white/5">
                        <span className="text-dim">{lang === "bg" ? "Хотел:" : "Hotel:"}</span>
                        <span className="text-gold font-light">{lang === "bg" ? "Добавена заявка" : "Added request"}</span>
                      </div>
                    )}
                  </div>
                </div>

                {/* Съобщение за краен срок */}
                <div className="bg-gold-crayola/10 border border-gold-crayola/30 p-3 mb-4 text-center">
                  <p 
                    className="text-gold text-sm"
                    style={{ fontFamily: 'var(--fontFamily-forum)' }}
                  >
                    {lang === "bg" 
                      ? "⏰ Заявките се приемат до 25 март 2026" 
                      : "⏰ Requests are accepted until March 25, 2026"}
                  </p>
                </div>

                {/* ДВА БУТОНА - И ДВАТА С ЕДНАКЪВ БЕЖОВ СТИЛ */}
                <div className="flex flex-col sm:flex-row gap-3">
                  {/* БУТОН ЗА ЛОКАЦИЯ - БЕЖОВ */}
                  <motion.button
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowLightbox(false);
                      setTimeout(() => {
                        const locationSection = document.getElementById("location-section");
                        if (locationSection) {
                          locationSection.scrollIntoView({ 
                            behavior: "smooth",
                            block: "start"
                          });
                        }
                      }, 100);
                    }}
                    className="flex-1 btn-gold py-4 text-base"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    {t.eventDateTime}
                  </motion.button>

                  {/* БУТОН ЗА РЕЗЕРВАЦИЯ НА СТАЯ - СЪЩО БЕЖОВ */}
                  <motion.button
                    onClick={(e) => {
                      e.stopPropagation();
                      setShowLightbox(false);
                      setTimeout(() => {
                        const hotelSection = document.querySelector('[data-testid="hotel-section"]');
                        if (hotelSection) {
                          hotelSection.scrollIntoView({ 
                            behavior: "smooth",
                            block: "start"
                          });
                        }
                      }, 100);
                    }}
                    className="flex-1 btn-gold py-4 text-base"
                    whileHover={{ scale: 1.02 }}
                    whileTap={{ scale: 0.98 }}
                  >
                    {t.reserveRoom}
                  </motion.button>
                </div>

                <p className="text-dim text-xs text-center mt-3 opacity-70">
                  {t.viewEventDetails}
                </p>
              </>
            )}
          </motion.div>
        </motion.div>
      )}

      {/* Hotel Lightbox */}
      <HotelLightbox 
        show={showHotelLightbox}
        onClose={() => setShowHotelLightbox(false)}
        roomType={selectedRoomType}
        t={t}
        lang={lang} 
      />
      
      {/* Noise Texture */}
      <div className="noise-overlay" />

      {/* Language Toggle */}
      <div className="lang-toggle" data-testid="language-toggle">
        <button
          className={`lang-btn ${lang === "bg" ? "active" : ""}`}
          onClick={() => setLang("bg")}
          data-testid="lang-btn-bg"
        >
          BG
        </button>
        <button
          className={`lang-btn ${lang === "en" ? "active" : ""}`}
          onClick={() => setLang("en")}
          data-testid="lang-btn-en"
        >
          EN
        </button>
      </div>

      {/* HERO SECTION */}
      <section className="hero-section grid-bg min-h-screen flex items-center" data-testid="hero-section">
        {/* Decorative Elements Left */}
        <div className="absolute left-8 md:left-16 top-1/2 -translate-y-1/2 hidden md:flex flex-col items-center gap-4">
          <motion.div 
            className="w-px h-24 bg-gradient-to-b from-transparent via-gold-crayola to-transparent"
            style={{ background: 'linear-gradient(to bottom, transparent, var(--gold-crayola), transparent)' }}
            initial={{ scaleY: 0 }}
            animate={{ scaleY: 1 }}
            transition={{ duration: 1.2, delay: 0.5 }}
          />
          <motion.div 
            id="event-date-section"
            className="text-gold text-xs tracking-[0.3em] writing-vertical"
            style={{ writingMode: 'vertical-rl', color: 'var(--gold-crayola)', opacity: 0.5 }}
            initial={{ opacity: 0 }}
            animate={{ opacity: 0.5 }}
            transition={{ duration: 1, delay: 1 }}
          >
            {t.date}
          </motion.div>
          <motion.div 
            className="w-px h-24 bg-gradient-to-b from-transparent via-gold-crayola to-transparent"
            style={{ background: 'linear-gradient(to bottom, transparent, var(--gold-crayola), transparent)' }}
            initial={{ scaleY: 0 }}
            animate={{ scaleY: 1 }}
            transition={{ duration: 1.2, delay: 0.7 }}
          />
        </div>

        {/* Decorative Elements Right */}
        <div className="absolute right-8 md:right-16 top-1/2 -translate-y-1/2 hidden md:flex flex-col items-center gap-4">
          <motion.div 
            className="w-px h-24"
            style={{ background: 'linear-gradient(to bottom, transparent, var(--gold-crayola), transparent)' }}
            initial={{ scaleY: 0 }}
            animate={{ scaleY: 1 }}
            transition={{ duration: 1.2, delay: 0.6 }}
          />
          <motion.div 
            className="flex flex-col gap-2 items-center"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 1, delay: 1.2 }}
          >
            <div className="w-2 h-2 rotate-45 border border-gold-crayola" style={{ borderColor: 'var(--gold-crayola)' }} />
            <div className="w-1.5 h-1.5 rotate-45 bg-gold-crayola" style={{ backgroundColor: 'var(--gold-crayola)' }} />
            <div className="w-2 h-2 rotate-45 border border-gold-crayola" style={{ borderColor: 'var(--gold-crayola)' }} />
          </motion.div>
          <motion.div 
            className="w-px h-24"
            style={{ background: 'linear-gradient(to bottom, transparent, var(--gold-crayola), transparent)' }}
            initial={{ scaleY: 0 }}
            animate={{ scaleY: 1 }}
            transition={{ duration: 1.2, delay: 0.8 }}
          />
        </div>

        {/* Corner Accents */}
        <motion.div 
          className="absolute top-8 left-8 w-16 h-16 border-l border-t hidden md:block"
          style={{ borderColor: 'rgba(212, 175, 55, 0.3)' }}
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.3 }}
        />
        <motion.div 
          className="absolute top-8 right-8 w-16 h-16 border-r border-t hidden md:block"
          style={{ borderColor: 'rgba(212, 175, 55, 0.3)' }}
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        />
        <motion.div 
          className="absolute bottom-8 left-8 w-16 h-16 border-l border-b hidden md:block"
          style={{ borderColor: 'rgba(212, 175, 55, 0.3)' }}
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.5 }}
        />
        <motion.div 
          className="absolute bottom-8 right-8 w-16 h-16 border-r border-b hidden md:block"
          style={{ borderColor: 'rgba(212, 175, 55, 0.3)' }}
          initial={{ opacity: 0, scale: 0.5 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
        />

        <div className="w-full max-w-7xl mx-auto px-4 md:px-8 relative z-10">
          {/* Flex layout with image above content on mobile, side by side on desktop */}
          <div className="flex flex-col md:flex-row md:items-center md:gap-8 lg:gap-16">
            {/* Image - Full width on mobile, left side on desktop */}
            <motion.div 
              className="image-frame w-full md:w-3/5 lg:w-1/2 mx-auto md:mx-0 mb-6 md:mb-0"
              style={{ border: '2px solid var(--gold-crayola)' }}
              initial={{ opacity: 0, scale: 0.8 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 1, ease: [0.16, 1, 0.3, 1] }}
              data-testid="image-placeholder"
            >
              <div className="aspect-[3/4] overflow-hidden">
                <img 
                  src="/images/krasimir-balakov.jpg" 
                  alt="Krasimir Balakov" 
                  className="w-full h-full object-cover md:scale-105"
                />
              </div>
            </motion.div>

            {/* Content - Full width on mobile, right side on desktop */}
            <div className="w-full md:w-2/5 lg:w-1/2 text-center md:text-left">
              {/* Mobile: Centered layout */}
              <div className="md:hidden">
                <motion.div
                  initial={{ opacity: 0, y: 50 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.2 }}
                  className="mb-1"
                >
                  <span 
                    className="font-forum tracking-wider"
                    style={{ 
                      fontSize: 'clamp(8rem, 28vw, 16rem)',
                      color: 'var(--gold-crayola)',
                      lineHeight: 0.8,
                      display: 'block',
                      fontWeight: 200
                    }}
                    data-testid="hero-title"
                  >
                    {t.heroTitle}
                  </span>
                </motion.div>

                <motion.p
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.3 }}
                  className="text-white tracking-[0.5em] text-2xl mb-3 font-light"
                  style={{ fontFamily: 'var(--fontFamily-forum)' }}
                >
                  {t.heroSubtitle}
                </motion.p>

                <motion.h1
                  initial={{ opacity: 0, y: 30 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.4 }}
                  className="tracking-[0.3em] mb-1"
                  style={{ 
                    fontFamily: 'var(--fontFamily-forum)',
                    fontSize: 'clamp(1.8rem, 5vw, 2.5rem)',
                    color: 'var(--quick-silver)',
                    fontWeight: 300
                  }}
                >
                  {t.heroName}
                </motion.h1>

                <motion.p
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.8, delay: 0.5 }}
                  className="text-dim tracking-[0.2em] text-lg mb-6"
                  style={{ fontFamily: 'var(--fontFamily-dm_sans)' }}
                  data-testid="hero-subtitle"
                >
                  {t.heroTagline}
                </motion.p>
              </div>

              {/* Desktop: Left-aligned layout */}
              <div className="hidden md:block">
                <motion.div
                  initial={{ opacity: 0, x: -50 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8, delay: 0.2 }}
                  className="mb-4"
                >
                  <span 
                    className="font-forum tracking-wider inline-block"
                    style={{ 
                      fontSize: 'clamp(6rem, 14vw, 14rem)',
                      color: 'var(--gold-crayola)',
                      lineHeight: 0.8,
                      fontWeight: 200
                    }}
                    data-testid="hero-title"
                  >
                    {t.heroTitle}
                  </span>
                </motion.div>

                <motion.p
                  initial={{ opacity: 0, x: -50 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8, delay: 0.3 }}
                  className="text-white tracking-[0.5em] text-2xl mb-4 font-light"
                  style={{ fontFamily: 'var(--fontFamily-forum)' }}
                >
                  {t.heroSubtitle}
                </motion.p>

                <motion.h1
                  initial={{ opacity: 0, x: -50 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8, delay: 0.4 }}
                  className="tracking-[0.3em] mb-3"
                  style={{ 
                    fontFamily: 'var(--fontFamily-forum)',
                    fontSize: 'clamp(2rem, 3.5vw, 3rem)',
                    color: 'var(--quick-silver)',
                    fontWeight: 300
                  }}
                >
                  {t.heroName}
                </motion.h1>

                <motion.p
                  initial={{ opacity: 0, x: -50 }}
                  animate={{ opacity: 1, x: 0 }}
                  transition={{ duration: 0.8, delay: 0.5 }}
                  className="text-dim tracking-[0.2em] text-lg mb-8"
                  style={{ fontFamily: 'var(--fontFamily-dm_sans)' }}
                  data-testid="hero-subtitle"
                >
                  {t.heroTagline}
                </motion.p>
              </div>

              {/* THANK YOU TEXT */}
              <motion.div
                className="mt-2 mb-6 md:mt-4 md:mb-8 text-center md:text-left max-w-2xl"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: 0.6 }}
              >
                <p 
                  className="text-silver leading-relaxed italic"
                  style={{ 
                    fontFamily: 'var(--fontFamily-forum)',
                    fontSize: 'clamp(1.2rem, 3vw, 1.5rem)',
                    letterSpacing: '0.03em',
                    borderLeft: '2px solid var(--gold-crayola)',
                    paddingLeft: '1.5rem',
                    opacity: 0.9
                  }}
                  data-testid="thankyou-text"
                >
                  {t.thankyou}
                </p>
                
              </motion.div>
            </div>
          </div>
        </div>
      </section>

      {/* Event Details SECTION */}
      <section className="section-darker py-16 md:py-24 px-4 md:px-6" data-testid="details-section" ref={detailsRef}>
        {/* Anchor for date scroll */}
        <div id="event-date-section" className="absolute -top-24 left-0 invisible" />

        <div className="max-w-5xl mx-auto">
          <motion.div 
            className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-4"
            variants={staggerContainer}
            initial="hidden"
            animate={detailsInView ? "visible" : "hidden"}
          >
            {/* Date */}
            <motion.div className="detail-card col-span-2 md:col-span-1" variants={popUp}>
              <Calendar className="mx-auto mb-4 md:mb-4" style={{ color: 'var(--gold-crayola)' }} size={28} />
              <p className="text-dim text-xs md:text-xs tracking-[0.2em] mb-2 md:mb-2">{t.dateLabel}</p>
              <p className="text-gold text-xl md:text-xl tracking-wider font-light" data-testid="event-date">{t.date}</p>
            </motion.div>

            {/* Welcome Drink */}
            <motion.div className="detail-card" variants={popUp}>
              <Clock className="mx-auto mb-4 md:mb-4" style={{ color: 'var(--gold-crayola)' }} size={28} />
              <p className="text-dim text-xs md:text-xs tracking-[0.15em] md:tracking-[0.2em] mb-2 md:mb-2">{t.welcomeDrink}</p>
              <p className="text-white text-xl md:text-xl tracking-wider font-light" data-testid="welcome-time">{t.welcomeTime}</p>
            </motion.div>

            {/* Dinner */}
            <motion.div className="detail-card" variants={popUp}>
              <Clock className="mx-auto mb-4 md:mb-4" style={{ color: 'var(--gold-crayola)' }} size={28} />
              <p className="text-dim text-xs md:text-xs tracking-[0.15em] md:tracking-[0.2em] mb-2 md:mb-2">{t.dinner}</p>
              <p className="text-white text-xl md:text-xl tracking-wider font-light" data-testid="dinner-time">{t.dinnerTime}</p>
            </motion.div>

            {/* Dress Code */}
            <motion.div className="detail-card col-span-2 md:col-span-1" variants={popUp}>
              <Shirt className="mx-auto mb-4 md:mb-4" style={{ color: 'var(--gold-crayola)' }} size={28} />
              <p className="text-dim text-xs md:text-xs tracking-[0.2em] mb-2 md:mb-2">{t.dresscodeLabel}</p>
              <p className="text-gold text-xl md:text-xl tracking-wider font-light" data-testid="dresscode">{t.dresscode}</p>
            </motion.div>
          </motion.div>
        </div>
      </section>

      {/* LOCATION SECTION */}
      <section id="location-section" className="section-dark py-16 md:py-24 px-4 md:px-6"  data-testid="location-section">
        <AnimatedSection className="max-w-5xl mx-auto">
          <div className="text-center mb-8 md:mb-12">
            <MapPin className="mx-auto mb-4 md:mb-4" style={{ color: 'var(--gold-crayola)' }} size={36} />
            <h2 
              className="text-gold tracking-[0.3em] mb-3"
              style={{ 
                fontFamily: 'var(--fontFamily-forum)',
                fontSize: 'clamp(1.5rem, 5vw, 2.5rem)',
                fontWeight: 300
              }}
            >
              {t.locationLabel}
            </h2>
            <p className="text-dim text-sm md:text-sm tracking-wider mb-2">{t.parkingLabel}: {t.parking}</p>
            <p className="text-gold text-xs md:text-sm tracking-wider mb-4">бул. „Симеоновско шосе“ 4, София</p>
            <div className="gold-line" />
          </div>
          
          {/* Map Container */}
          <div className="relative" style={{ border: '1px solid rgba(212, 175, 55, 0.2)' }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d11754.110811111194!2d23.333724775866506!3d42.66019119740269!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40aa863d5f3bfbdb%3A0x4c2a0f1e8c8e8e8e!2z0JvQvtCy0LXQvSwg0LHRg9C7LiDigJ7QodC40LzQtdC-0L3QvtCy0YHQutC-INCo0L7RgdC14oCcIDQsIDE3MDAg0KHQvtGE0LjRjw!5e0!3m2!1sbg!2sbg!4v1700000000000!5m2!1sbg!2sbg"
              width="100%"
              height="300"
              className="md:h-[400px]"
              style={{ border: 0, filter: 'grayscale(100%) invert(92%) contrast(83%)' }}
              allowFullScreen=""
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              title="Event Location"
              data-testid="google-map"
            />
            <a 
              href={GOOGLE_MAPS_LINK}
              target="_blank"
              rel="noopener noreferrer"
              className="absolute bottom-3 right-3 md:bottom-4 md:right-4 btn-gold text-sm md:text-sm py-3 px-5 md:py-3 md:px-6"
              data-testid="map-link"
            >
              {t.location}
            </a>
          </div>
        </AnimatedSection>
      </section>

      {/* MENU SECTION */}
      <section className="section-darker py-16 md:py-24 px-4 md:px-6" id="menu-section" data-testid="menu-section" ref={menuRef}>
        <div className="max-w-2xl md:max-w-4xl lg:max-w-6xl mx-auto">
          <AnimatedSection className="text-center mb-12">
            <h2 
              className="text-gold tracking-[0.4em] mb-4"
              style={{ 
                fontFamily: 'var(--fontFamily-forum)',
                fontSize: 'clamp(2rem, 6vw, 3rem)',
                fontWeight: 300
              }}
              data-testid="menu-title"
            >
              {t.menuTitle}
            </h2>
            <div className="gold-line" />
          </AnimatedSection>

          {/* ПЪРВИ РЕД - 2 САЛАТИ */}
          <motion.div
            className="mb-12"
            variants={popUp}
            initial="hidden"
            animate={menuInView ? "visible" : "hidden"}
          >
            <div className="text-center mb-6">
              <h3 
                className="text-gold tracking-[0.2em]"
                style={{ 
                  fontFamily: 'var(--fontFamily-forum)',
                  fontSize: 'clamp(1.1rem, 4vw, 1.4rem)',
                  fontWeight: 300
                }}
              >
                {t.saladSection.title}
              </h3>
            </div>

            {/* Responsive grid за салатите */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-8">
              {t.saladSection.items.map((item, index) => (
                <motion.div 
                  key={item.id}
                  className="group flex flex-col h-full"
                  variants={popUp}
                >
                  <div className="text-center mb-2 md:mb-3">
                    <h4 
                      className="text-gold tracking-wider leading-tight"
                      style={{ 
                        fontFamily: 'var(--fontFamily-forum)',
                        fontSize: 'clamp(1rem, 4vw, 1.2rem)'
                      }}
                    >
                      {item.title}
                    </h4>
                    <p 
                      className="text-dim text-xs md:text-sm tracking-wide mt-1"
                      style={{ fontFamily: 'var(--fontFamily-dm_sans)' }}
                    >
                      {item.description}
                    </p>
                  </div>

                  {/* КОНТЕЙНЕР ЗА СНИМКА - по-малък на мобилно */}
                  <div className="flex justify-center">
                    <div 
                      className="relative w-full md:w-full max-w-[280px] md:max-w-none aspect-[3/4] overflow-hidden cursor-pointer transition-transform duration-300 hover:scale-[1.02] flex-1"
                      style={{ 
                        background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.08), rgba(255, 255, 255, 0.02))',
                        border: '1px solid rgba(255, 255, 255, 0.05)'
                      }}
                      onClick={() => item.image && setLightboxImage({ src: item.image, title: item.title })}
                    >
                      {item.image ? (
                        <img 
                          src={item.image} 
                          alt={item.title} 
                          className="w-full h-full object-cover"
                        />
                      ) : (
                        <div className="absolute inset-0 flex items-center justify-center">
                          <ImageIcon size={20} className="md:w-8 md:h-8" style={{ color: 'rgba(212, 175, 55, 0.2)' }} />
                        </div>
                      )}
                      <div 
                        className="absolute top-2 left-2 w-8 h-8 md:w-9 md:h-9 flex items-center justify-center text-xs md:text-xs tracking-wider"
                        style={{ 
                          background: 'rgba(0,0,0,0.7)',
                          border: '1px solid var(--gold-crayola)',
                          color: 'var(--gold-crayola)'
                        }}
                      >
                        {String(index + 1).padStart(2, '0')}
                      </div>
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* ВТОРИ РЕД - 1 ПАСТА */}
          <motion.div
            className="mb-12"
            variants={popUp}
            initial="hidden"
            animate={menuInView ? "visible" : "hidden"}
          >
            <div className="text-center mb-6">
              <div className="gold-line mb-4" style={{ opacity: 0.3 }} />
              <h3 
                className="text-gold tracking-[0.2em]"
                style={{ 
                  fontFamily: 'var(--fontFamily-forum)',
                  fontSize: 'clamp(1.1rem, 4vw, 1.4rem)',
                  fontWeight: 300
                }}
              >
                {t.pastaSection.title}
              </h3>
            </div>

            <div className="flex justify-center">
              <motion.div 
                className="group flex flex-col h-full w-full md:w-3/4 lg:w-2/3 xl:w-1/2"
                variants={popUp}
              >
                <div className="text-center mb-2 md:mb-3">
                  <p 
                    className="text-dim text-xs md:text-sm tracking-wide"
                    style={{ fontFamily: 'var(--fontFamily-dm_sans)' }}
                  >
                    {t.pastaSection.description}
                  </p>
                </div>

                {/* КОНТЕЙНЕР ЗА СНИМКА - по-малък на мобилно */}
                <div className="flex justify-center">
                  <div 
                    className="relative w-full md:w-full max-w-[280px] md:max-w-none aspect-[3/4] overflow-hidden cursor-pointer transition-transform duration-300 hover:scale-[1.02] flex-1"
                    style={{ 
                      background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.08), rgba(255, 255, 255, 0.02))',
                      border: '1px solid rgba(255, 255, 255, 0.05)'
                    }}
                    onClick={() => t.pastaSection.image && setLightboxImage({ src: t.pastaSection.image, title: t.pastaSection.title })}
                  >
                    {t.pastaSection.image ? (
                      <img 
                        src={t.pastaSection.image} 
                        alt={t.pastaSection.title} 
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="absolute inset-0 flex items-center justify-center">
                        <ImageIcon size={20} className="md:w-8 md:h-8" style={{ color: 'rgba(212, 175, 55, 0.2)' }} />
                      </div>
                    )}
                  </div>
                </div>
              </motion.div>
            </div>
          </motion.div>

          {/* ТРЕТИ РЕД - 3 ОСНОВНИ */}
          <motion.div
            className="mt-8"
            variants={popUp}
            initial="hidden"
            animate={menuInView ? "visible" : "hidden"}
          >
            <div className="text-center mb-6">
              <div className="gold-line mb-4" style={{ opacity: 0.3 }} />
              <h3 
                className="text-gold tracking-[0.2em]"
                style={{ 
                  fontFamily: 'var(--fontFamily-forum)',
                  fontSize: 'clamp(1.1rem, 4vw, 1.4rem)',
                  fontWeight: 300
                }}
              >
                {t.mainCourses.title}
              </h3>
            </div>

            {/* Responsive grid за основните ястия */}
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5 lg:gap-6">
              {t.mainCourses.items.map((item) => (
                <motion.div 
                  key={item.id}
                  className="group flex flex-col h-full"
                  variants={popUp}
                >
                  <div className="text-center mb-2 md:mb-3">
                    <h4 
                      className="text-gold tracking-wider leading-tight"
                      style={{ 
                        fontFamily: 'var(--fontFamily-forum)',
                        fontSize: 'clamp(1rem, 3vw, 1.1rem)'
                      }}
                    >
                      {item.title}
                    </h4>
                    <p 
                      className="text-dim text-xs md:text-sm tracking-wide mt-1"
                      style={{ fontFamily: 'var(--fontFamily-dm_sans)' }}
                    >
                      {item.description}
                    </p>
                  </div>

                  {/* КОНТЕЙНЕР ЗА СНИМКА - по-малък на мобилно */}
                  <div className="flex justify-center">
                    <div 
                      className="relative w-full md:w-full max-w-[280px] md:max-w-none aspect-[3/4] overflow-hidden cursor-pointer transition-transform duration-300 hover:scale-[1.02] flex-1"
                      style={{ 
                        background: 'linear-gradient(135deg, rgba(212, 175, 55, 0.08), rgba(255, 255, 255, 0.02))',
                        border: '1px solid rgba(255, 255, 255, 0.05)'
                      }}
                      onClick={() => item.image && setLightboxImage({ src: item.image, title: item.title })}
                    >
                      {item.image ? (
                        <img 
                          key={lang + item.id}
                          src={item.image} 
                          alt={item.title} 
                          className="w-full h-full object-cover"
                        />
                      ) : (
                        <div className="absolute inset-0 flex items-center justify-center">
                          <ImageIcon size={20} className="md:w-8 md:h-8" style={{ color: 'rgba(212, 175, 55, 0.2)' }} />
                        </div>
                      )}
                    </div>
                  </div>
                </motion.div>
              ))}
            </div>
          </motion.div>

          {/* БУТОН ЗАПАЗИ МЯСТО - ПОКАЗВА СЕ САМО АКО СРОКЪТ НЕ Е ИЗТЕКЪЛ */}
          {!registrationClosed && (
            <motion.div
              className="text-center mt-12"
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: 0.5, duration: 0.8 }}
            >
              <motion.button
                onClick={scrollToRSVP}
                className="btn-gold px-8 py-4 text-base md:text-lg"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                data-testid="cta-button-menu"
              >
                {t.cta}
              </motion.button>
              <p className="text-dim text-xs mt-3 tracking-wider opacity-60">
                {lang === "bg" ? "Потвърди присъствие" : "Confirm attendance"}
              </p>
            </motion.div>
          )}

          <div className="gold-line mt-8" />
        </div>
      </section>

      {/* HOTEL SECTION - ПОД МЕНЮТО И НАД ЗАЯВКИТЕ */}
      <HotelSection t={t} onBookClick={handleHotelBook} lang={lang} />

      {/* ATTENDANCE SECTION */}
      <section className="section-darker py-24 px-6" data-testid="attendance-section">
        <AnimatedSection className="max-w-2xl mx-auto text-center">
          <Clock className="mx-auto mb-6" style={{ color: 'var(--gold-crayola)' }} size={44} />
          <h3 className="text-gold tracking-[0.3em] mb-8 text-base">{t.attendanceTitle}</h3>
          
          {/* Deadline Warning */}
          <div className="border-t border-gold-crayola/20 pt-8">
            <div className="inline-block bg-gold-crayola/10 border border-gold-crayola/30 p-4 px-6">
              <p 
                className="text-gold font-bold tracking-wider mb-1"
                style={{ 
                  fontFamily: 'var(--fontFamily-forum)',
                  fontSize: 'clamp(1rem, 2vw, 1.2rem)'
                }}
              >
                ⏰ {t.attendanceDeadline}
              </p>
              <p 
                className="text-dim text-sm"
                style={{ fontFamily: 'var(--fontFamily-dm_sans)' }}
              >
                {t.attendanceDeadlineWarning}
              </p>
            </div>
          </div>
        </AnimatedSection>
      </section>

      {/* RSVP SECTION ИЛИ REGISTRATION CLOSED SECTION */}
      {registrationClosed ? (
        // ПОКАЗВА СЕ СЕКЦИЯТА "ЗАПИСВАНЕТО ПРИКЛЮЧИ"
        <RegistrationClosedSection t={t} lang={lang} />
      ) : (
        // ПОКАЗВА СЕ ОРИГИНАЛНАТА ФОРМА ЗА ЗАПИСВАНЕ
        <section className="section-dark py-16 md:py-24 px-4 md:px-6" id="rsvp-section" data-testid="rsvp-section">
          <AnimatedSection className="max-w-lg mx-auto">
            <div className="text-center mb-8 md:mb-10">
              <h2 
                className="text-gold tracking-[0.3em]"
                style={{ 
                  fontFamily: 'var(--fontFamily-forum)',
                  fontSize: 'clamp(1.5rem, 5vw, 2.5rem)',
                  fontWeight: 300
                }}
                data-testid="rsvp-title"
              >
                {t.rsvpTitle}
              </h2>
              <p className="text-dim tracking-[0.2em] text-sm md:text-sm mt-2">{t.rsvpSubtitle}</p>
              <div className="gold-line" />
            </div>

            {submitted ? (
              <motion.div 
                className="text-center py-12 md:py-16"
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                data-testid="rsvp-success"
              >
                <motion.div 
                  className="text-gold text-5xl md:text-6xl mb-6"
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ delay: 0.2, type: "spring" }}
                >
                  ✓
                </motion.div>
                <p className="text-silver tracking-wider text-base md:text-base">{t.successMessage}</p>
              </motion.div>
            ) : (
              <div className="form-container p-4 md:p-8">
                <form onSubmit={handleSubmit} data-testid="rsvp-form">
                  {/* Брой гости */}
                  <div className="mb-5 md:mb-6">
                    <label className="text-dim text-xs md:text-xs tracking-[0.2em] block mb-2 md:mb-3">
                      {t.guestCount} *
                    </label>
                    <select
                      name="guestCount"
                      value={formData.guestCount}
                      onChange={handleInputChange}
                      className="input-modern text-base md:text-base py-3 md:py-4"
                      data-testid="select-guestcount"
                    >
                      <option value="1">{t.guestCount1}</option>
                      <option value="2">{t.guestCount2}</option>
                    </select>
                  </div>

                  {/* Име на първи гост */}
                  <div className="mb-5 md:mb-6">
                    <label className="text-dim text-xs md:text-xs tracking-[0.2em] block mb-2 md:mb-3">
                      {t.formLabels.guest1Name} *
                    </label>
                    <input
                      type="text"
                      name="fullName"
                      value={formData.fullName}
                      onChange={handleInputChange}
                      className="input-modern text-base md:text-base py-3 md:py-4"
                      placeholder={t.placeholders.fullName}
                      required
                      data-testid="input-fullname"
                    />
                  </div>

                  {/* Име на втори гост - само при избор на 2 */}
                  {formData.guestCount === "2" && (
                    <div className="mb-5 md:mb-6">
                      <label className="text-dim text-xs md:text-xs tracking-[0.2em] block mb-2 md:mb-3">
                        {t.formLabels.guest2Name} *
                      </label>
                      <input
                        type="text"
                        name="guest2Name"
                        value={formData.guest2Name}
                        onChange={handleInputChange}
                        className="input-modern text-base md:text-base py-3 md:py-4"
                        placeholder={t.placeholders.guestName}
                        required
                        data-testid="input-guest2name"
                      />
                    </div>
                  )}

                  {/* Избор на салата - Гост 1 */}
                  <div className="mb-5 md:mb-6">
                    <label className="text-dim text-xs md:text-xs tracking-[0.2em] block mb-2 md:mb-3">
                      {t.formLabels.saladChoice1} *
                    </label>
                    <select
                      name="saladChoice1"
                      value={formData.saladChoice1}
                      onChange={handleInputChange}
                      className="input-modern text-base md:text-base py-3 md:py-4"
                      data-testid="select-saladchoice1"
                    >
                      <option value="traditional">{t.saladOptions.traditional}</option>
                      <option value="goatCheese">{t.saladOptions.goatCheese}</option>
                    </select>
                  </div>

                  {/* Избор на основно ястие - Гост 1 */}
                  <div className="mb-5 md:mb-6">
                    <label className="text-dim text-xs md:text-xs tracking-[0.2em] block mb-2 md:mb-3">
                      {t.formLabels.foodChoice1} *
                    </label>
                    <select
                      name="foodChoice1"
                      value={formData.foodChoice1}
                      onChange={handleInputChange}
                      className="input-modern text-base md:text-base py-3 md:py-4"
                      data-testid="select-foodchoice1"
                    >
                      <option value="fish">{t.foodOptions.fish}</option>
                      <option value="veal">{t.foodOptions.veal}</option>
                      <option value="porkRibs">{t.foodOptions.porkRibs}</option>
                    </select>
                  </div>

                  {/* Избор на салата - Гост 2 - само при избор на 2 */}
                  {formData.guestCount === "2" && (
                    <div className="mb-5 md:mb-6">
                      <label className="text-dim text-xs md:text-xs tracking-[0.2em] block mb-2 md:mb-3">
                        {t.formLabels.saladChoice2} *
                      </label>
                      <select
                        name="saladChoice2"
                        value={formData.saladChoice2}
                        onChange={handleInputChange}
                        className="input-modern text-base md:text-base py-3 md:py-4"
                        data-testid="select-saladchoice2"
                      >
                        <option value="traditional">{t.saladOptions.traditional}</option>
                        <option value="goatCheese">{t.saladOptions.goatCheese}</option>
                      </select>
                    </div>
                  )}

                  {/* Избор на основно ястие - Гост 2 - само при избор на 2 */}
                  {formData.guestCount === "2" && (
                    <div className="mb-5 md:mb-6">
                      <label className="text-dim text-xs md:text-xs tracking-[0.2em] block mb-2 md:mb-3">
                        {t.formLabels.foodChoice2} *
                      </label>
                      <select
                        name="foodChoice2"
                        value={formData.foodChoice2}
                        onChange={handleInputChange}
                        className="input-modern text-base md:text-base py-3 md:py-4"
                        data-testid="select-foodchoice2"
                      >
                        <option value="fish">{t.foodOptions.fish}</option>
                        <option value="veal">{t.foodOptions.veal}</option>
                        <option value="porkRibs">{t.foodOptions.porkRibs}</option>
                      </select>
                    </div>
                  )}

                  {/* Специални изисквания (алергени) */}
                  <div className="mb-6 md:mb-8">
                    <label className="text-dim text-xs md:text-xs tracking-[0.2em] block mb-2 md:mb-3">
                      {t.formLabels.specialRequirements}
                    </label>
                    <textarea
                      name="specialRequirements"
                      value={formData.specialRequirements}
                      onChange={handleInputChange}
                      className="input-modern text-base md:text-base py-3 md:py-4"
                      rows={3}
                      placeholder={t.placeholders.specialRequirements}
                      style={{ resize: 'none' }}
                      data-testid="textarea-requirements"
                    />
                  </div>

                  {/* Hotel Needed - КВАДРАТНИ TICK-ове, НАЙ-ОТДОЛУ ПРЕДИ БУТОНА */}
                  <div className="mb-6 md:mb-8 pt-4 border-t border-gold-crayola/20">
                    <label className="text-dim text-xs md:text-xs tracking-[0.2em] block mb-4 md:mb-4">
                      {t.formLabels.hotelNeeded}
                    </label>
                    <div className="flex flex-row gap-6 sm:gap-8">
                      <label className="flex items-center cursor-pointer group">
                        <div className="relative flex items-center">
                          <input
                            type="checkbox"
                            name="hotelNeededNo"
                            checked={formData.hotelNeeded === "no"}
                            onChange={() => {
                              setFormData(prev => ({
                                ...prev,
                                hotelNeeded: prev.hotelNeeded === "no" ? "yes" : "no"
                              }));
                            }}
                            className="sr-only"
                          />
                          <div className={`w-5 h-5 border-2 mr-2 flex items-center justify-center transition-all duration-200 ${
                            formData.hotelNeeded === "no" 
                              ? 'border-gold-crayola bg-gold-crayola' 
                              : 'border-dim group-hover:border-gold-crayola/50'
                          }`}>
                            {formData.hotelNeeded === "no" && (
                              <svg className="w-3.5 h-3.5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                              </svg>
                            )}
                          </div>
                          <span className={`text-sm md:text-sm tracking-wide transition-colors ${
                            formData.hotelNeeded === "no" ? 'text-gold-crayola' : 'text-silver group-hover:text-white'
                          }`}>
                            {t.hotelOptions.no}
                          </span>
                        </div>
                      </label>
                      
                      <label className="flex items-center cursor-pointer group">
                        <div className="relative flex items-center">
                          <input
                            type="checkbox"
                            name="hotelNeededYes"
                            checked={formData.hotelNeeded === "yes"}
                            onChange={() => {
                              setFormData(prev => ({
                                ...prev,
                                hotelNeeded: prev.hotelNeeded === "yes" ? "no" : "yes"
                              }));
                            }}
                            className="sr-only"
                          />
                          <div className={`w-5 h-5 border-2 mr-2 flex items-center justify-center transition-all duration-200 ${
                            formData.hotelNeeded === "yes" 
                              ? 'border-gold-crayola bg-gold-crayola' 
                              : 'border-dim group-hover:border-gold-crayola/50'
                          }`}>
                            {formData.hotelNeeded === "yes" && (
                              <svg className="w-3.5 h-3.5 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={3}>
                                <path strokeLinecap="round" strokeLinejoin="round" d="M5 13l4 4L19 7" />
                              </svg>
                            )}
                          </div>
                          <span className={`text-sm md:text-sm tracking-wide transition-colors ${
                            formData.hotelNeeded === "yes" ? 'text-gold-crayola' : 'text-silver group-hover:text-white'
                          }`}>
                            {t.hotelOptions.yes}
                          </span>
                        </div>
                      </label>
                    </div>
                    <p className="text-dim text-xs mt-3 opacity-60 italic">
                      * При избор на "Да", ще бъдете пренасочени към хотел секцията за резервация
                    </p>
                  </div>

                  <motion.button
                    type="submit"
                    className="btn-gold w-full text-sm md:text-sm py-4 md:py-4"
                    disabled={isSubmitting}
                    whileHover={{ scale: 1.01 }}
                    whileTap={{ scale: 0.99 }}
                    data-testid="submit-button"
                  >
                    {isSubmitting ? t.telegramSending : t.formLabels.submit}
                  </motion.button>
                </form>
              </div>
            )}
          </AnimatedSection>
        </section>
      )}

      {/* FOOTER */}
      <footer className="py-12 text-center" style={{ background: '#030303' }} data-testid="footer">
        <div className="gold-line-vertical" />
        <p className="text-dim text-sm tracking-[0.3em] mt-6">
          {t.footerName} — 60
        </p>
        <p className="text-dim text-xs tracking-[0.2em] mt-2 opacity-60">
          бул. „Симеоновско шосе“ 4, София
        </p>
      </footer>
    </div>
  );
}

export default App;